import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { CancellationPolicyAction } from "./APIs/action/index";
import useContentProtection from "../Common/useContentProtection";

const CancellationPolicy = ({ inModal = false })  => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);
  const { onContextMenu, protectionSx } = useContentProtection();

  useEffect(() => {
    const getPolicy = async () => {
        setLoading(true);
        const data = await CancellationPolicyAction();
        setPolicy(data);
        setLoading(false);
    };
    getPolicy();
  }, []);

  if (!policy) return null;

  return (
    <Box onContextMenu={onContextMenu} sx={{ p: 2, display: 'flex', gap: 2, flexDirection: 'column', ...protectionSx }}>
      {!inModal && <Typography variant="h1">{policy?.title}</Typography>}
      {(policy?.description)
        ? (
          <Box component="ol" sx={{ m: 0, pl: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
            {policy?.description.map((para, idx) => (
              <Box component="li" key={idx}>
                <Typography variant="body1">{para}</Typography>
              </Box>
            ))}
          </Box>
        )
        : <Typography variant="body1">{policy?.description}</Typography>
      }
    </Box>
  );
};

export default CancellationPolicy;